import { useTranslation } from "next-i18next";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Router from "next/router";

import Text from "ab-text";
import Input from "ab-input";
import { sendPasswordResetEmail, resetUserPassword } from "ab-api-mutations";
import Button from "ab-form-button";

import "./ab-forgot-password.scss";

const ForgotPassword = ({
  formTitle,
  emailPlaceholder,
  resetKey,
  i18n,
  user,
}) => {
  const { t } = useTranslation("common", { i18n });

  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
      email: "",
      key: !!resetKey,
      password: "",
      passwordConfirm: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email()
        .when("key", {
          is: false,
          then: Yup.string().required(t("validationEmail")),
        }),
      password: Yup.string().when("key", {
        is: true,
        then: Yup.string()
          .required(t("validationPassword"))
          .matches(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
            t("validationPasswordFormat")
          ),
      }),
      passwordConfirm: Yup.string().when("key", {
        is: true,
        then: Yup.string()
          .oneOf([Yup.ref("password"), null], t("validationPasswordConfirm"))
          .required(t("validationPassword")),
      }),
    }),
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      if (resetKey) {
        resetUserPassword(user, resetKey, values.password).then((res) => {
          // console.log("loginresult", res);
          // if (
          //   res?.[0]?.message ===
          //   "There is no user registered with that email address."
          // ) {
          //   setError("No existe un usuario registrado con ese email.");
          // }

          setLoading(false);
          Router.push("/login");
        });
      } else {
        sendPasswordResetEmail(values.email).then((res) => {
          // console.log("loginresult", res);
          if (
            res?.[0]?.message ===
            "There is no user registered with that email address."
          ) {
            setError(
              i18n?.language == "en"
                ? res?.[0]?.message
                : "No existe un usuario registrado con ese email."
            );
          }

          setLoading(false);
          setIsSent(true);
        });
      }
    },
  });
  // console.log("ForgotPasswordForm ", resetKey);
  const { values, setFieldValue, handleSubmit, errors } = formik;
  return (
    <div className="ab-forgot-password">
      {isSent ? (
        <form>
          <Text element="h3">{formTitle || t("titleForgot")}</Text>
          <Text>{t("emailSent")}</Text>
        </form>
      ) : (
        <form onSubmit={handleSubmit}>
          <Text element="h3">{formTitle || t("titleForgot")}</Text>

          {values.key ? (
            <>
              <Input
                placeholder={t("password")}
                value={values.password}
                onChange={(val) => setFieldValue("password", val)}
                type="password"
                error={errors.password}
              />
              <Input
                placeholder={t("passwordConfirm")}
                value={values.passwordConfirm}
                onChange={(val) => setFieldValue("passwordConfirm", val)}
                type="password"
                error={errors.passwordConfirm}
              />
            </>
          ) : (
            <Input
              placeholder={emailPlaceholder || t("email")}
              value={values.email}
              onChange={(val) => setFieldValue("email", val)}
            />
          )}

          {error ? <div>{error}</div> : null}

          <Button loading={loading}>{t("button")}</Button>
        </form>
      )}
    </div>
  );
};

export default ForgotPassword;
